varying vec4 vPickColor;

void main() {
  gl_FragColor = vPickColor;
}
